import { useEffect } from 'react';
import {
  compareUTMStringWithLocalStorage,
  getUTMQueryString,
  saveUTMStringToLocalStorage,
} from '../UTMContainer.utils';

const useUTMTracker = () => {
  useEffect(() => {
    // Get the UTM query string from the current URL
    const utmQueryString = getUTMQueryString(window.location.search);

    // Only proceed if there are UTM parameters present
    if (utmQueryString) {
      // Compare with the stored UTM string in localStorage
      const isMatch = compareUTMStringWithLocalStorage(utmQueryString);

      // If it doesn't match, update localStorage
      if (!isMatch) {
        saveUTMStringToLocalStorage(utmQueryString);
      }
    }
  }, []);
};

export default useUTMTracker;
